<script>
    export let size = 24
    export let color = '#00669E'
    export let style = ''
    export let title = null
</script>

<svg
    width={`${size}`}
    height={`${size}`}
    {style}
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    {#if title}
        <title>{title}</title>
    {/if}
    <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.36 8.5C15.36 12.5647 12.0647 15.86 8 15.86C3.93528 15.86 0.64 12.5647 0.64 8.5C0.64 4.43528 3.93528 1.14 8 1.14C12.0647 1.14 15.36 4.43528 15.36 8.5ZM16 8.5C16 4.08181 12.4182 0.5 8 0.5C3.58181 0.5 0 4.08181 0 8.5C0 12.9182 3.58181 16.5 8 16.5C12.4182 16.5 16 12.9182 16 8.5ZM7.2768 11.7H8.64V6.7368H7.2768V11.7ZM7.2768 4.8456H8.64V5.9688H7.2768V4.8456Z"
        fill={color}
    ></path>
    <mask
        id="mask0_4235_38869"
        style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="17"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.36 8.5C15.36 12.5647 12.0647 15.86 8 15.86C3.93528 15.86 0.64 12.5647 0.64 8.5C0.64 4.43528 3.93528 1.14 8 1.14C12.0647 1.14 15.36 4.43528 15.36 8.5ZM16 8.5C16 4.08181 12.4182 0.5 8 0.5C3.58181 0.5 0 4.08181 0 8.5C0 12.9182 3.58181 16.5 8 16.5C12.4182 16.5 16 12.9182 16 8.5ZM7.2768 11.7H8.64V6.7368H7.2768V11.7ZM7.2768 4.8456H8.64V5.9688H7.2768V4.8456Z"
            fill="white"
        ></path>
    </mask>
    <g mask="url(#mask0_4235_38869)">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0.5H16V16.5H0V0.5Z"
            fill="#00669E"
        ></path>
    </g>
</svg>
